var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/ApplicationConstants.js');
var ActionTypes = Constants.ActionTypes;

module.exports = {
    updateSpecialRequestsModel: function (fieldId, value) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_SPECIAL_REQUESTS,
            fieldId: fieldId,
            value: value
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/SpecialRequestsActions.js